import type { ComponentPropsWithRef } from "react";

export const XIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.2216 10.1624L22.9147 0H20.8547L13.3065 8.82384L7.27772 0H0.32428L9.44092 13.3432L0.32428 24H2.38438L10.3555 14.6817L16.7223 24H23.6757L14.2211 10.1624H14.2216ZM11.4 13.4608L10.4763 12.1321L3.12667 1.55962H6.29086L12.2221 10.0919L13.1458 11.4206L20.8556 22.5113H17.6914L11.4 13.4613V13.4608Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
